// PNG export - S47.3a / S47.3b / S48.1.
// Renderiza la etiqueta a un HTMLCanvas off-screen y la exporta como PNG.
// Sin librerias externas. Resolucion 300 DPI nominal.
//
// S48.1: acepta `bundle` para resolver bindKeys de tipo bundle.* (DEMO).
import { findSize } from '../utils';
import { valueForField } from '../dynamicFields';
import {
  drawQrOnCanvas,
  drawCode128OnCanvas,
  drawTextAutoFit,
} from './canvas_renderer';

const PX_PER_MM = 300 / 25.4;

function _drawField(ctx, f, producto, bundle, scale) {
  const value = valueForField(f, producto, bundle);
  const x = f.xMm * scale;
  const y = f.yMm * scale;
  const w = f.wMm * scale;
  const h = f.hMm * scale;
  if (f.type === 'qr') return drawQrOnCanvas(ctx, value, x, y, w, h);
  if (f.type === 'barcode') return drawCode128OnCanvas(ctx, value, x, y, w, h);
  if (f.type === 'price') {
    return drawTextAutoFit(ctx, value, x, y, w, h, { mono: true, bold: true, color: '#000' });
  }
  if (f.type === 'sku') {
    return drawTextAutoFit(ctx, value, x, y, w, h, { mono: true, color: '#000' });
  }
  return drawTextAutoFit(ctx, value, x, y, w, h, { color: '#000' });
}

export function renderEtiquetaPng(state, producto, bundle) {
  if (!state || typeof state !== 'object') return null;
  if (typeof document === 'undefined') return null;
  const sz = findSize(state.sizeId);
  const scale = PX_PER_MM;
  const wPx = Math.round(sz.wMm * scale);
  const hPx = Math.round(sz.hMm * scale);
  const canvas = document.createElement('canvas');
  canvas.width = wPx;
  canvas.height = hPx;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, wPx, hPx);
  const fields = Array.isArray(state.fields) ? state.fields : [];
  for (let i = 0; i < fields.length; i += 1) {
    _drawField(ctx, fields[i], producto, bundle, scale);
  }
  return canvas.toDataURL('image/png');
}

function _safeName(s) {
  return String(s || '').replace(/[^A-Za-z0-9_-]+/g, '-').replace(/^-+|-+$/g, '');
}

function _suffix(producto, bundle) {
  if (bundle && bundle.code) return '-' + _safeName(bundle.code);
  if (producto && (producto.sku || producto.codigo)) {
    return '-' + _safeName(producto.sku || producto.codigo);
  }
  return '';
}

export function downloadEtiquetaPng(state, producto, bundle) {
  const dataUrl = renderEtiquetaPng(state, producto, bundle);
  if (!dataUrl) return false;
  if (typeof document === 'undefined') return false;
  const sizeBit = _safeName((state && state.sizeId) || 'etiqueta');
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = 'etiqueta-' + sizeBit + _suffix(producto, bundle) + '.png';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
}
